import LogsPage from './logs-page';

export default LogsPage;